import TimerOutlinedIcon from '@mui/icons-material/TimerOutlined'
import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined';
import { ClockIcon } from '@mui/x-date-pickers'
import {
  BusinessCenterOutlined,
  CalendarTodayOutlined,
  DashboardOutlined,
  InsightsOutlined,
  ListAltOutlined,
  PaidOutlined,
  ReceiptLongOutlined,
} from '@mui/icons-material'
import TaskOutlinedIcon from '@mui/icons-material/TaskOutlined';
import MonitorHeartOutlinedIcon from '@mui/icons-material/MonitorHeartOutlined';


const fontSize = { xs: 18, lg: 24 }

export const navList = [
  {
    title: 'Homepage',
    icon: <DashboardOutlined sx={{ fontSize }} />,
    link: '/app/homepage',
    baseRoute: 'homepage',
  },
  {
    title: 'Leave',
    // icon: <CalendarTodayIcon sx={{ fontSize }} />,
    icon: <CalendarTodayOutlined sx={{ fontSize }} />,

    link: '/app/leave',
    baseRoute: 'leave',
    items: [
      {
        title: 'My Request',
        link: '/request',
      },
      {
        title: 'Leave Credit Request',
        link: '/leave_credit',
      },
      {
        title: 'Calendar',
        link: '/calendar',
      },
    ],
  },
  {
    title: 'Claim',
    icon: <ReceiptLongOutlined sx={{ fontSize }} />,
    link: '/app/claim',
    baseRoute: 'claim',
  },
  // {
  //   title: 'Performance',
  //   icon: <InsertChartOutlined sx={{ fontSize }} />,
  //   link: '/app/performance',
  //   baseRoute: 'performance',
  //   items: [
  //     {
  //       title: 'Appraisal',
  //       link: '/appraisal',
  //     },
  //     {
  //       title: 'Work Personality Fit',
  //       link: '/assessment',
  //     },
  //   ],
  // },
  {
    title: 'Tasks Dashboard',
    icon: <TaskOutlinedIcon sx={{ fontSize }} />,
    link: '/app/tasks-dashboard',
    baseRoute: 'tasks-dashboard',

    items: [
      {
        title: 'Project Tracker',
        link: '/project-tracker',
      },
      {
        title: 'My Tasks',
        link: '/my-tasks',
      },
      // {
      //   title: 'Project Tracker',
      //   link: '/project-tracker',
      // },
      {
        title: 'Leaderboard',
        link: '/leaderboard',
      },
    ],
  },
  {
    title: 'Time & Attendance',
    icon: <TimerOutlinedIcon sx={{ fontSize }} />,
    link: '/app/attendance',
    baseRoute: 'attendance',
    beta: true,
  },
  {
    title: 'Appraisal',
    icon: <MonitorHeartOutlinedIcon sx={{ fontSize }} />,
    link: '/app/performance/appraisal',
    baseRoute: 'performance/appraisal',
    beta: true,
  },
  // {
  //   title: 'Upskill',
  //   icon: <DashboardCustomizeIcon sx={{ fontSize }} />,
  //   link: '/app/upskill',
  //   baseRoute: 'upskill',
  // },
]

export const navAdminList = [
  {
    //check for use case where a user does not have admin role BUT CAN APPROVE CLAIM/LEAVE
    title: 'Approvals',
    icon: <ListAltOutlined sx={{ fontSize }} />,
    link: '/app/approval-center',
    baseRoute: 'approval-center',
    requireRole: true,
    permissionId: 10,
    items: [
      {
        requireRole: true,
        permissionId: '',
        title: 'Leave',
        link: '/leave',
      },
      {
        requireRole: true,
        permissionId: '',
        title: 'Claim',
        link: '/claim',
      },
      {
        requireRole: false,
        permissionId: 12,
        title: 'Reimbursement',
        link: '/reimbursement',
      },
      // {
      //   title: 'Upskill',
      //   link: '/upskill',
      // },
    ],
  },

  {
    title: 'Payroll',
    icon: <PaidOutlined sx={{ fontSize }} />,
    link: '/app/payroll',
    baseRoute: 'payroll',
    requireRole: false,
    permissionId: 1,
    items: [
      {
        requireRole: false,
        permissionId: 7,
        title: 'Payroll',
        link: '/dashboard',
      },
      {
        requireRole: false,
        permissionId: 8,
        title: 'Payroll History',
        link: '/payroll-history',
      },
      {
        requireRole: false,
        permissionId: 9,
        title: 'Yearly Report',
        link: '/yearly-report',
      },
    ],
  },
  {
    title: 'Recruitment',
    icon: <BusinessCenterOutlined sx={{ fontSize }} />,
    link: '/app/recruitment',
    baseRoute: 'recruitment',
    requireRole: false,
    permissionId: 18,
    items: [
      {
        requireRole: false,
        title: 'Applicant Tracking',
        link: '/applicant-tracking',
      },
      // {
      //   title: 'Cart',
      //   link: '/cart',
      // },
      // {
      //   title: 'Cart',
      //   link: '/cart',
      // },
      {
        requireRole: false,
        title: 'Talent Upload',
        link: '/external-talent',
      },
      {
        requireRole: false,
        title: 'Recruiter Calendar',
        link: '/recruiter-calendar',
      },
      // {
      //   title: 'Credit balance',
      //   link: '/credit',
      // },
    ],
  },
  {
    title: 'Performance Centre',
    icon: <InsightsOutlined sx={{ fontSize }} />,
    link: '/app/appraisal-cycle',
    baseRoute: 'appraisal-cycle',
    requireRole: false,
    permissionId: 17,
    items: [
      {
        requireRole: false,
        title: 'Appraisal',
        link: '/dashboard',
        alternateRoute: 'details',
      },
      {
        requireRole: false,
        title: 'Work Personality Fit',
        link: '/work-personality-fit-analysis',
      },
      // {
      //   title: 'Upskill Progression',
      //   link: '/upskill-progression',
      // },
    ],
  },
  {
    title: 'Attendance Records',
    icon: <ClockIcon />,
    link: '/app/attendance-records',
    baseRoute: 'attendance-records',
    requireRole: false,
    beta: true,
    permissionId: 20,
  },
  // hide staff retention for fastlane
  // {
  //   title: 'Staff Retention',
  //   icon: <PieChartIcon sx={{ fontSize }} />,
  //   link: '/app/staff-retention',
  //   baseRoute: 'staff-retention',
  //   items: [
  //     {
  //       title: 'Overview',
  //       link: '/dashboard',
  //     },
  //     {
  //       title: 'Demographics',
  //       link: '/demographics',
  //     },
  //     {
  //       title: 'Predicted Attrition',
  //       link: '/predicted-attritions',
  //     },
  //   ],
  // },
]
